module.exports = require("./lkt-US.js");